<template>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    created() {
        console.log('tadaa', this)
        const customListeners = this.item.listeners
        for (const property in customListeners) {
            console.log(`on ${property}: ${customListeners[property]}`)
            this.$on(property, customListeners[property])
        }
    },
    destroyed() {
        const customListeners = this.item.listeners
        for (const property in customListeners) {
            console.log(`off ${property}: ${customListeners[property]}`)
            this.$off(property, customListeners[property])
        }
    },
    // computed: {
    //     customListeners() {
    //         const self = this
    //         return Object.assign(
    //             {},
    //             this.$listeners,
    //             item.listeners
    //         )
    //     }
    // },
    methods: {
        removeModal() {
            this.$emitBubbleFirst('remove', this)
        }
    }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/modules/modals/components/ModalBase.vue